import { Modal, Row, Col, Card, CarouselItem } from 'react-bootstrap'
import React, { Component } from 'react'
import parse, { domToReact } from 'html-react-parser';
import './summary.scss';

class SingleStudentDataModal extends Component {

    render() {
        let stateData = this.props.stateData.studentResults;
        return (

            <Modal {...this.props}
                size="lg" aria-labelledby="example-modal-sizes-title-lg" className="">
                <Modal.Header closeButton>
                    <Modal.Title id="example-modal-sizes-title-lg text-center">Student Results</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {
                        stateData.map((item, index) => {
console.log("qtype",item.qtype)
                            if (item.qtype == "3" || item == "9") {
                                let question1 = item.question.replace(/src="/g, 'src=\\"');
                                let question2 = question1.replace(/" \/>/g, '\\" />');
                                let question = [];
                                let selectedStudent = item.studentResults.filter((item2) => item2.mobile == this.props.stateData.mobile);
                                try {
                                    question = JSON.parse(question2);
                                }
                                catch (err) {
                                    console.log("MATRIX ERROR:", err.message);
                                }

                                return (
                                    <>
                                        <Card as={Card.Body} className="bg-light my-2">
                                            <Row>
                                                <Col xl={12} lg={12} md={12} sm={12}>
                                                    <Row>
                                                        <Col xl={6} lg={6} md={6} sm={12} className="my-2">
                                                    <span className='font-weight-bold'>{item.slno}</span>
                                                            <h6 className='text-center font-weight-bold'>List-I</h6>
                                                            <ol className="matrixlistoptions" type={
                                                                item.list1type == "alphabets" ? ("A")
                                                                    : (item.list1type == "numbers") ? ("1")
                                                                        : ("roman")}
                                                            >
                                                                {question.map((item) => (
                                                                    <li className='text-center font-weight-bold'>{parse(item.qlist1)}</li>
                                                                ))}
                                                            </ol>
                                                        </Col>
                                                        <Col xl={6} lg={6} md={6} sm={12} className="my-2">
                                                        <h6 className='text-center font-weight-bold'>List-II</h6>
                                                            <ol className="matrixlistoptions" type={
                                                                item.list2type == "alphabets" ? ("A")
                                                                    : (item.list2type == "numbers") ? ("1")
                                                                        : ("roman")}>
                                                                {question.map((item) => (
                                                                    <li className='text-center font-weight-bold'>{parse(item.qlist2)}</li>
                                                                ))}
                                                            </ol>
                                                        </Col>
                                                    </Row>
                                                    <Row>
                                                        <Col xl={6} lg={6} md={6} sm={12} className="my-2">
                                                            <div className="d-flex align-items-center">
                                                                <span className='f-16'>A.</span>
                                                                <div className="ml-2">{parse(item.option1)}</div>
                                                            </div>
                                                        </Col>
                                                        <Col xl={6} lg={6} md={6} sm={12} className="my-2">
                                                            <div className="d-flex align-items-center">
                                                                <span className='f-16'>B.</span>
                                                                <div className="ml-2">{parse(item.option2)}</div>
                                                            </div>
                                                        </Col>
                                                        <Col xl={6} lg={6} md={6} sm={12} className="my-2">
                                                            <div className="d-flex align-items-center">
                                                                <span className='f-16'>C.</span>
                                                                <div className="ml-2">{parse(item.option3)}</div>
                                                            </div>
                                                        </Col>
                                                        <Col xl={6} lg={6} md={6} sm={12} className="my-2">
                                                            <div className="d-flex align-items-center">
                                                                <span className='f-16'>D.</span>
                                                                <div className="ml-2">{parse(item.option4)}</div>
                                                            </div>
                                                        </Col>
                                                    </Row>
                                                    <Row>
                                                        <Col xl={12} lg={12} md={12} sm={12} className="my-2">
                                                            <div className="d-flex align-items-center color_000">
                                                                <span className="font-weight-bold">Correct Answer:</span>
                                                                <div className="font-weight-bold ml-2">{item.answer}</div>
                                                                <span className="font-weight-bold ml-4">Attempted Answer:</span>
                                                                {
                                                                    selectedStudent.map((item) => (
                                                                        <div className="font-weight-bold ml-2">{item.attempt_answer}</div>
                                                                    ))
                                                                }
                                                            </div>
                                                        </Col>

                                                    </Row>
                                                </Col>

                                            </Row>

                                        </Card>
                                    </>
                                )
                            }
                            else if (item.qtype == "8") {
                                return (
                                    <Card as={Card.Body} className="bg-light my-2">
                                        {parse(item.question)}
                                        <Row>
                                            <Col xl={12} lg={12} md={12} sm={12} className="my-2">
                                                <div className="d-flex align-items-center color_000">
                                                    <span className="font-weight-bold">Correct Answer:</span>
                                                    <div className="font-weight-bold ml-2">{item.answer}</div>
                                                </div>
                                            </Col>
                                        </Row>
                    
                                    </Card>
                                )
                    
                            }
                            else if (item.qtype == "5") {
                                //console.log("questionsData.questionnn", question);
                                return (<Card as={Card.Body} className="bg-light my-2">
                                    {parse(item.question)}
                                    <Row>
                                        <Col xl={6} lg={6} md={6} sm={12} className="my-2">
                                            <div className="d-flex align-items-center">
                                                <span className='f-16'>A.</span>
                                                <div className="ml-2">{parse(item.option1)}</div>
                                            </div>
                                        </Col>
                                        <Col xl={6} lg={6} md={6} sm={12} className="my-2">
                                            <div className="d-flex align-items-center">
                                                <span className='f-16'>B.</span>
                                                <div className="ml-2">{parse(item.option2)}</div>
                                            </div>
                                        </Col>
                                        <Col xl={6} lg={6} md={6} sm={12} className="my-2">
                                            <div className="d-flex align-items-center">
                                                <span className='f-16'>C.</span>
                                                <div className="ml-2">{parse(item.option3)}</div>
                                            </div>
                                        </Col>
                                        <Col xl={6} lg={6} md={6} sm={12} className="my-2">
                                            <div className="d-flex align-items-center">
                                                <span className='f-16'>D.</span>
                                                <div className="ml-2">{parse(item.option4)}</div>
                                            </div>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col xl={12} lg={12} md={12} sm={12} className="my-2 ">
                                            <div className="d-flex align-items-center color_000">
                                                <span className="font-weight-bold">Correct Answer:</span>
                                                <div className="font-weight-bold ml-2">{item.answer}</div>
                                            </div>
                                        </Col>
                                    </Row>
                    
                                </Card>)
                            }
                            else {
                                let selectedStudent = item.studentResults.filter((item2) => item2.mobile == this.props.stateData.mobile);
                                console.log("selectedStudent", typeof selectedStudent)
                                return (
                                    <div className='d-flex'>
                                        <Card as={Card.Body} className="bg-light my-2">
                                            <Row>
                                                <Col xl={12} lg={12} md={12} sm={12}>
                                                    <Row>
                                                        <Col xl={12} lg={12} md={12} sm={12} className="my-2">
                                                            <div className="d-flex align-items-center" >
                                                                <span className='font-weight-bold'>{item.slno}</span>
                                                                <div className="ml-2 font-weight-bold ">{parse(item.question)}</div>

                                                            </div>
                                                        </Col>
                                                    </Row>
                                                    {/* <hr className="my-1" /> */}
                                                    <Row>
                                                        <Col xl={6} lg={6} md={6} sm={12} className="my-2">
                                                            <div className="d-flex align-items-center">
                                                                <span className='f-16'>A.</span>
                                                                <div className="ml-2">{parse(item.option1)}</div>
                                                            </div>
                                                        </Col>
                                                        <Col xl={6} lg={6} md={6} sm={12} className="my-2">
                                                            <div className="d-flex align-items-center">
                                                                <span className='f-16'>B.</span>
                                                                <div className="ml-2">{parse(item.option2)}</div>
                                                            </div>
                                                        </Col>
                                                        <Col xl={6} lg={6} md={6} sm={12} className="my-2">
                                                            <div className="d-flex align-items-center">
                                                                <span className='f-16'>C.</span>
                                                                <div className="ml-2">{parse(item.option3)}</div>
                                                            </div>
                                                        </Col>
                                                        <Col xl={6} lg={6} md={6} sm={12} className="my-2">
                                                            <div className="d-flex align-items-center">
                                                                <span className='f-16'>D.</span>
                                                                <div className="ml-2">{parse(item.option4)}</div>
                                                            </div>
                                                        </Col>
                                                    </Row>
                                                    <Row>
                                                        <Col xl={12} lg={12} md={12} sm={12} className="my-2">
                                                            <div className="d-flex align-items-center color_000">
                                                                <span className="font-weight-bold">Correct Answer:</span>
                                                                <div className="font-weight-bold ml-2">{item.answer}</div>
                                                                <span className="font-weight-bold ml-4">Attempted Answer:</span>
                                                                {
                                                                    selectedStudent.map((item) => (
                                                                        <div className="font-weight-bold ml-2">{item.attempt_answer}</div>
                                                                    ))
                                                                }
                                                            </div>
                                                        </Col>
                                                    </Row>
                                                </Col>
                                            </Row>
                                        </Card>
                                    </div>
                                )
                            }
                        })
                    }
                </Modal.Body>
            </Modal>
        )
    }
}

export default SingleStudentDataModal;
